import React from 'react';
import './header.scss';

export class ClaimsMenu extends React.Component {

  render() {
    return (
      <div className="navbar-dropdown-inner2">
        <div className="header-container header-container-claims">
          <div className="header-products header-claims">
            <div className="header-products__items">
              <div className="header-products__items-image-section">
                <p className="product-name"></p>
              </div>
              <div className="sub-products-container">
                <ul className="sub-products-container-list claims-container-list">
                  <li>
                    <a href="/claims">Claim Intimation</a>
                  </li>
                  <li>
                    <a href="https://api.whatsapp.com/send?phone=9915070204&amp;text=Hi">Claim Status</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}